module.exports = __webpack_public_path__ + "img/header-engagementRingsRedgold@2x.2d6da8a.jpg";